// extracted by mini-css-extract-plugin
export default {"modal":"_3G-WzfUyXK","modal-absolute":"_2KJKKYD0Po","modalAbsolute":"_2KJKKYD0Po","modal-inline":"_3elc2WzpI3","modalInline":"_3elc2WzpI3","title-section":"_1o57cLIlJQ","titleSection":"_1o57cLIlJQ","logo":"_3BvFmgNNFx","line":"_1OcT9BIX2_","body":"_2FxmrlgMYC","message":"_4LDT4-fjfQ","control-bar":"_3bjXdlDuxH","controlBar":"_3bjXdlDuxH","shadow":"_2o0CvPOT8J"};
    if(module.hot) {
      // 1625219395905
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  